<div class="vo-actions">
  <button type="button" class="vo-btn vo-btn--ghost" (click)="back.emit()">
    <app-icon name="arrow-left" [size]="16"/>
    Zurück
  </button>

  <button type="button" class="vo-btn vo-btn--primary" [disabled]="busy" (click)="next.emit()">
    {{ isLastStep ? 'Anfrage absenden' : 'Weiter' }}
    <app-icon name="arrow-right" [size]="18"/>
  </button>

  <span class="vo-actions__counter" *ngIf="stepCount">Schritt {{ stepNumber }} von {{ stepCount }}</span>
</div>
